import { useEffect, useRef } from 'preact/hooks'

const useInterval = (callback: () => void, delay: number) => {
  const intervalRef = useRef<ReturnType<typeof setInterval>>()
  const savedCallback = useRef(callback)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    if (delay !== null) {
      intervalRef.current = setInterval(() => savedCallback.current(), delay)
      return () => clearInterval(intervalRef.current)
    }
  }, [delay, callback])

  return () => clearInterval(intervalRef.current)
}

export default useInterval
